import React, { useEffect, useState } from "react";
import JqxGrid, { jqx } from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";
import { Button, Image } from "react-bootstrap";
import { ExcelReporte } from "../../components/utils/Excel_produccion";

const ReporteVacaciones = () => {
  const cellClass = (row: number, columnfield: any, value: number): string => {
    if (parseInt(value) === 0) {
      return "green";
    }
    if (value >= 100) {
      return "OrangeRed";
    }
    if (value >= 1 && value <= 100) {
      return "Orange";
    }
  };
  const [columns] = useState([
    { text: "Code", datafield: "Code", width: "3%", pinned: true,},
    { text: "ID Empleado", datafield: "IDEmpleado", width: "5%", pinned: true,},
    { text: "Nombre Empleado", datafield: "NombreEmpleado", width: "20%", pinned: true,},
    { text: "Departamento", datafield: "Departamento", width: "8%", },
    { text: "Fecha Ingreso", datafield: "FechaIngreso", width: "8%", cellsformat: "dd/MM/yyyy" },
    { text: "Desde Fecha", datafield: "Desde_Fecha", width: "8%", cellsformat: "dd/MM/yyyy" },
    { text: "Hasta Fecha", datafield: "Hasta_Fecha", width: "8%", cellsformat: "dd/MM/yyyy" },
    { text: "Dias", datafield: "Dias", width: "3%", },
    { text: "FechaCorte", datafield: "FechaCorte", width: "8%", cellsformat: "dd/MM/yyyy" },
    { text: "FechaCorte 2", datafield: "FechaCorte2", width: "8%", cellsformat: "dd/MM/yyyy" },
    { text: "Dias Laborados", datafield: "DiasLaborados", width: "8%", },
    { text: "Periodos", datafield: "Periodos", width: "5%", },
    { text: "Periodos Gozados", datafield: "Periodos_Gozados", width: "8%", },
    { text: "Periodos Disponibles", datafield: "Periodos_Disponibles", width: "8%", },
    { text: "Dias a cuenta de vacaciones", datafield: "Dias_a_cuenta_de_vacaciones", width: "10%", },
    { text: "Dias Efectivos Vacaciones", datafield: "Dias_Efectivos_Vacaciones", width: "10%", cellclassname: cellClass,},




    // { text: "Fecha Corte", datafield: "FechaCorte", width: "8%", },
    // { text: "Dias a cuenta de vacaciones", datafield: "Dias_a_cuenta_de_vacaciones", width: "15%", },
    // { text: "Periodos disponibles", datafield: "Periodos_disponibles", width: "10%", },
    // { text: "Periodos gozados", datafield: "Periodos_gozados", width: "8%", },
    // { text: "Dias disponibles", datafield: "Dias_disponibles", cellclassname: cellClass, width: "10%", },
  ]);
  const [sourceGrid, setsourceGrid] = useState([]);
  useEffect(() => {
    let url = "http://190.56.9.222:8003/get-Reportevacaciones";
    // console.log(url)
    fetch(url) 
      .then((res) => res.json())
      .then((data) => {
        let tempArr = [];
        data.forEach((element) => {
          let arr = [
            element.Code,
            element.IDEmpleado,
            element.NombreEmpleado,
            element.Departamento,
            element.FechaIngreso,
            element.Desde_Fecha,
            element.Hasta_Fecha,
            element.Dias,
            element.FechaCorte,
            element.FechaCorte2,
            element.DiasLaborados,
            element.Periodos,
            element.Periodos_Gozados,
            element.Periodos_Disponibles,
            element.Dias_a_cuenta_de_vacaciones,
            element.Dias_Efectivos_Vacaciones,
          ];
          tempArr.push(arr);
        });
        let temp: any = {
          localdata: tempArr,
          datafields: [
            { name: "Code", type: "string", map: "0" },
            { name: "IDEmpleado", type: "string", map: "1" },
            { name: "NombreEmpleado", type: "string", map: "2" },
            { name: "Departamento", type: "string", map: "3" },
            { name: "FechaIngreso", type: "date", map: "4" },
            { name: "Desde_Fecha", type: "date", map: "5" },
            { name: "Hasta_Fecha", type: "date", map: "6" },
            { name: "Dias", type: "string", map: "7" },
            { name: "FechaCorte", type: "date", map: "8" },
            { name: "FechaCorte2", type: "date", map: "9" },
            { name: "DiasLaborados", type: "string", map: "10" },
            { name: "Periodos", type: "string", map: "11" },
            { name: "Periodos_Gozados", type: "string", map: "12" },
            { name: "Periodos_Disponibles", type: "string", map: "13" },
            { name: "Dias_a_cuenta_de_vacaciones", type: "string", map: "14" },
            { name: "Dias_Efectivos_Vacaciones", type: "string", map: "15" },
          ],
          datatype: "array",
        };
        setsourceGrid(new jqx.dataAdapter(temp));
      })
      .catch((error) => console.log(error, "error"));
  }, []);
  const excelBtnOnClick = () => {
    let name = "Reporte Vacaciones";
    let temp_columnas = [
      { Header: "Code" },
      { Header: "IDEmpleado" },
      { Header: "NombreEmpleado" },
      { Header: "Departamento" },
      { Header: "FechaIngreso" },
      { Header: "Desde_Fecha" },
      { Header: "Hasta_Fecha" },
      { Header: "Dias" },
      { Header: "FechaCorte" },
      { Header: "FechaCorte2" },
      { Header: "DiasLaborados" },
      { Header: "Periodos" },
      { Header: "Periodos_Gozados" },
      { Header: "Periodos_Disponibles" },
      { Header: "Dias_a_cuenta_de_vacaciones" },
      { Header: "Dias_Efectivos_Vacaciones" },

    ];
    let data_print = sourceGrid._source.localdata;
    ExcelReporte(data_print, temp_columnas, name);
  };
  return (
    <div className="content">
      <div className="row">
        <div
          className="col-sm-12"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Image
            width={"100px"}
            src="https://lh6.googleusercontent.com/ffvrJRfaDIBUenlScjntHRks8dnLKWHJNXfqojwYj4fpBgdASTP-1dMYAh0zoZ9EfrBLccahiNmfAUv6eMy6CY104SR9M69dByfNaEKWC2vkZWlNjY9bKaMMJA3fqOZJRA=w894"
          />
          <Image
            width={"100px"}
            src={"https://www.macizo.com.gt/assets/img/navbar-logo3.png"}
          />
        </div>
        <div
          className="col-sm-12"
          style={{
            justifyContent: "center",
            display: "flex",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          REPORTE DE VACACIONES
        </div>
        <br />
        <br />
        <div className="col-sm-12">
          <JqxGrid
            //   ref={myGrid}
            width={"100%"}
            height={"900px"}
            theme={"material"}
            columns={columns}
            source={sourceGrid}
            showgroupaggregates={true}
            showstatusbar={true}
            showaggregates={true}
            // statusbarheight={25}
            sortable={true}
            groupable={true}
            filterable={true}
            showfilterrow={true}
            // pagesize={20}
            // pageable={true}
            // autoheight={true}
            columnsresize={true}
            // selectionmode={"multiplerowsextended"}
          />
          <br />
          <center>
            <div>
              <Button onClick={excelBtnOnClick} bsStyle="primary" active>
                <i className="pe-7s-print" />
                Download Excel.
              </Button>
            </div>
          </center>
        </div>
      </div>
    </div>
  );
};

export default ReporteVacaciones;
